"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defaultScormData = JSON.stringify({
    lesson_location: '',
    credit: 'credit',
    entry: 'ab_initio',
    lesson_status: 'not attempted',
    total_time: '0000:00:00.00',
    score_row: '0',
    suspend_data: '',
    exit: '',
    session_time: '0000:00:00.00',
    interactions: '[]',
    progress_measure: '0'
});
exports.default = defaultScormData;
//# sourceMappingURL=defaultScormData.js.map